import { Callout, Kalender, KalenderLegend, ListEmpty, LoadingState } from 'admination-react'
import { ModalHeader } from '@/core/components/modal/ModalHeader'
import { useApp } from '@/core/state/appStore'
import { useAnwesenheitAktionen } from './AnwesenheitAktionen'
import { anwesenheitLegende, anwesenheitZelle, useAnwesenheitsliste, useKalenderZeitraum, zuweisungHinweis } from './anwesenheitKalender'

export function AnwesenheitPersonTab({ coachingId }: { coachingId: string }) {
  const { state, dispatch } = useApp()
  const { modus, zeitraum, steuerung } = useKalenderZeitraum('monat', state.screen?.kalenderAnker)
  const stand = useAnwesenheitsliste(true, modus, zeitraum)
  const aktionen = useAnwesenheitAktionen()
  const rows = stand.status === 'bereit' ? stand.personen.filter((person) => person.coaching_id === coachingId) : []
  return <>
    <ModalHeader onClose={() => dispatch({ type: 'CLOSE' })}>{steuerung}</ModalHeader>
    <div className="calendar-scroll" data-testid="anwesenheit-person">
      {stand.status === 'laedt' && <LoadingState>Die Anwesenheit wird geladen …</LoadingState>}
      {stand.status === 'fehler' && <Callout tone="error" role="alert" className="calendar-message" title={stand.meldung} />}
      {stand.status === 'bereit' && (rows.length === 0 ? <ListEmpty>Keine Anwesenheit vorhanden</ListEmpty> : <>
        <Kalender
          aria-label="Anwesenheit"
          density={stand.ansicht.modus === 'woche' ? 'week' : 'month'}
          inset
          rowLabel="Teilnehmende"
          totalLabel="Unentschuldigt"
          columns={stand.ansicht.spalten}
          rows={rows}
          rowKey={(person) => person.coaching_id}
          rowName={(person) => person.name}
          rowNote={zuweisungHinweis(stand.ansicht.zeitraum)}
          cell={anwesenheitZelle(stand.ansicht.modus, aktionen.eintragOeffnen)}
          rowActions={aktionen.zeilenMenue}
          total={(person) => person.unentschuldigt}
        />
        <KalenderLegend items={anwesenheitLegende(stand.ansicht.modus)} inset />
      </>)}
      {aktionen.dialog}
    </div>
  </>
}
